export const isOutOfStock = productDetails =>
    productDetails.stock.stockLevelStatus === 'outOfStock' ||
    productDetails.isOfflineProduct ||
    (Object.prototype.hasOwnProperty.call(productDetails, 'purchasable') &&
        !productDetails.purchasable);

export const isForbiddenCountry = (forbiddenCountries, selectedCountryISOCode) => {
    return forbiddenCountries.some(({ isocode }) => isocode === selectedCountryISOCode);
};
export const getSmallPromotionBadge = (
    promotions = [],
    markdownPromotion = {},
    useMarkDownPromotion = false, // BU specific feature config check
) => {
    if (useMarkDownPromotion) {
        const mdPromoRewardValue =
            markdownPromotion &&
            markdownPromotion.reward &&
            markdownPromotion.reward.formattedRewardValue;
        if (mdPromoRewardValue) {
            return mdPromoRewardValue;
        }
        return false;
    }

    const filterPromotions = ['GWP', 'FREE_ITEM'];
    const firstPromotion = promotions.find(
        ({ reward }) => reward && filterPromotions.indexOf(reward.rewardType) === -1,
    );
    return (firstPromotion && firstPromotion.reward.formattedRewardValue) || null;
};

export const getVariantCategoryName = (matrix = [], currentCode) => {
    const currentVariant = matrix.find(
        ({ variantOption: { code } = {} }) => currentCode === code,
    ) || { variantValueCategory: { name: '' } };
    return currentVariant.variantValueCategory.name;
};

export const hidePromotions = productDetails =>
    isOutOfStock(productDetails) ||
    (productDetails.masterBrand &&
        (productDetails.masterBrand.abrand ||
            productDetails.masterBrand.hidePromotionsAndMarkdownPrice));

export const hideRoundel = masterBrand =>
    masterBrand && masterBrand.abrand && masterBrand.hideRoundel;

const getImageUrlFromVariantOption = ({ variantOptionQualifiers }) => {
    return variantOptionQualifiers[0] && variantOptionQualifiers[0].image
        ? variantOptionQualifiers[0].image.url
        : '';
};

const mapVariantOption = variantOption => {
    const {
        stock: { stockLevelStatus },
        priceData: { formattedValue, formattedOldValue },
        topPromotion: { reward = {} } = {},
    } = variantOption;

    const imageUrl = getImageUrlFromVariantOption(variantOption);
    return {
        code: variantOption.code,
        value: variantOption.url,
        stock: stockLevelStatus,
        price: formattedValue,
        promo: reward.formattedRewardValue,
        image: imageUrl,
        type: imageUrl ? 'MEDIA_URL' : 'HEX_CODE',
        rrpEnabled: variantOption.rrpEnabled,
        mdPromoRewardValue: variantOption.mdPromotionRoundelValue,
        otherPrices: variantOption.otherPrices,
        priceObj: variantOption.priceData,
        ...(formattedOldValue ? { oldPrice: formattedOldValue } : {}),
    };
};

const mapVariantValueCategory = variantValue => {
    const { code: color, name: label } = variantValue;
    return { color, label };
};

export const mapVariants = variants => {
    return (variants || []).map(({ variantOption, variantValueCategory }) => ({
        ...mapVariantValueCategory(variantValueCategory),
        ...mapVariantOption(variantOption),
    }));
};

export const lastGalleryIndex = (images = []) => {
    const last = images[images.length - 1];
    return last && last.galleryIndex >= 0 ? last.galleryIndex : 0;
};

export const createVideoThumbnails = (length, startGalleryIndex, thumbnailSrc) =>
    [...Array(length)].map((_, i) => ({
        format: 'thumbnail',
        galleryIndex: startGalleryIndex + i,
        imageType: 'GALLERY',
        url: thumbnailSrc,
    }));

export const updateVariantURL = (productDetails, code) => {
    if (productDetails) {
        let url = productDetails.url;
        const result = /[^/]*$/.exec(url)[0];
        return url ? url.replace(result, code) : '';
    }
    return '';
};

export default {
    isOutOfStock,
    mapVariants,
    createVideoThumbnails,
    lastGalleryIndex,
    getSmallPromotionBadge,
    hidePromotions,
    getVariantCategoryName,
    hideRoundel,
    updateVariantURL,
    isForbiddenCountry,
};
